import { useRef, useState } from "react";
import { CalendarLogo, MailIconFilled, NotificationIcon } from "../../../icons";
import NotificationSlideOver from "./NotificationsSlideover";
import { useRecoilValue } from "recoil";
import { unreadNotifications } from "../../../config/recoil/atoms";

const Notifications = () => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [toggled, setToggled] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const notifications = useRecoilValue(unreadNotifications)
   
    /**
     *  check if there is any new notification
     * @returns
     */
    const newNotifications = (type?: "conversation" | "appointment") => {
        if (!notifications?.count) return false;
        if (type) return notifications.notification?.some((n) => n.category === type);
        else
            return notifications.notification?.some(
                (n) => n.category !== "conversation" && n.category !== "appointment"
            );
    };

    const onClick = (value: boolean) => {
        setDisabled(true);
        setToggled(value);
        setTimeout(() => setDisabled(false), 500);
    };

    const [type, setType] = useState<"" | "conversation" | "appointment">("");

    return (
        <div
            ref={wrapperRef}
            className="flex flex-col items-center justify-center relative cursor-pointer z-10"
        >
            <div className="flex flex-row">
                <div
                    onClick={() => {
                        if (!disabled) {
                            setToggled(true);
                            setType("");
                        }
                    }}
                    className={"relative"}
                >
                    {newNotifications() && (
                        <span className="flex h-3 w-3 absolute right-0 top-0">
                            <span className="animate-ping-slow absolute inline-flex h-full w-full rounded-full bg-color2 opacity-75 "></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-color2 border-2 md:border-color8 border-color1"></span>
                        </span>
                    )}
                    <NotificationIcon className="md:text-color7 text-color8 fill-current h-6 w-6" />
                </div>
                <div
                    onClick={() => {
                        if (!disabled) {
                            setToggled(true);
                            setType("conversation");
                        }
                    }}
                    className={"relative ml-4"}
                >
                    {newNotifications("conversation") && (
                        <span className="flex h-3 w-3 absolute right-0 top-0">
                            <span className="animate-ping-slow absolute inline-flex h-full w-full rounded-full bg-color2 opacity-75 "></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-color2 border-2 md:border-color8 border-color1"></span>
                        </span>
                    )}
                    <MailIconFilled className="md:text-color7 text-color8 fill-current h-6 w-6" />
                </div>
                <div
                    onClick={() => {
                        if (!disabled) {
                            setToggled(true);
                            setType("appointment");
                        }
                    }}
                    className={"relative ml-4 flex items-center"}
                >
                    {newNotifications("appointment") && (
                        <span className="flex h-3 w-3 absolute right-0 top-0">
                            <span className="animate-ping-slow absolute inline-flex h-full w-full rounded-full bg-color2 opacity-75 "></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-color2 border-2 md:border-color8 border-color1"></span>
                        </span>
                    )}
                    <CalendarLogo className="md:text-color7 text-color8 fill-current h-6 w-6" />
                </div>
            </div>
            <NotificationSlideOver open={toggled} setOpen={onClick} type={type} />
        </div>
    );
};

export default Notifications;
